import Ajax from "base/Ajax";
import Message from "base/Message";
import AjaxConfirmModal from "modals/AjaxConfirmModal";

export default class SubscriptionEntryItem {
    constructor($item) {
        this.$item = $item;
        this.id = this.$item.attr("data-entry");
        this.subscription = this.$item.attr("data-subscription");
        this.context = this.$item.attr("data-context");

        this.bindEvents();
    }

    bindEvents() {
        const me = this;

        this.$item.on("click", ".js-cancel-entry", function () {
            let $this = $(this);

            let modal = new AjaxConfirmModal("Are you sure you want to cancel this subscription entry?", undefined, () => {
                return Ajax.post("billing", "subscriptions/" + me.subscription + "/entries/" + me.id + "/cancel");
            });
            modal.on("success", (entry) => {
                console.log(entry);
                new Message("This subscription entry has been successfully cancelled", "Subscription Entry Cancelled", Message.SUCCESS, {
                    autoHide: false,
                });
                modal.destroy();

                // Disable button to avoid re-sending
                $this.attr("disabled", true);
            });
            modal.show();

            return false;
        });
    }

    static findAll() {
        return $(".js-subscription-entry-item").map((_, el) => new SubscriptionEntryItem($(el))).get();
    }
}
